/*
* @Author: ç¯çç§æ(Lucas Huang)
* @Date: 2018-12-14 14:40:48
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-09-25 18:10:29
* @Company: Inspur
* @Version: v0.0.1
*/

import { Component, OnInit, ViewChild, ViewContainerRef, EventEmitter, Output,
    ComponentFactoryResolver, ComponentRef, ChangeDetectorRef, Injector, ReflectiveInjector, OnDestroy
} from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';

import { DataTableComponent } from '@farris/ui-datatable';
import { TreeNode, TreeTableComponent } from '@farris/ui-treetable';

import { LOAD_DATA_TYPE, LookupGridOptions, LookupGridResult } from './lookup-grid-options';
import { LookupGridComponent } from './lookup-grid.component';
import { filter, switchMap } from 'rxjs/operators';
import { FilterCondition } from '@farris/ui-common/types';

@Component({
    selector: 'lookup-left',
    templateUrl: './lookup-left.component.html'
})

export class LookupLeftComponent implements OnInit, OnDestroy {

    cmpRef: ComponentRef<any>;
    navOptions: LookupGridOptions;
    lookupCmp: LookupGridComponent;

    navConditions: Array<FilterCondition> = [];


    @ViewChild('container', {read: ViewContainerRef}) cmpContainer: ViewContainerRef;
    @Output() selected = new EventEmitter<{ data: any, node?: any}>();
    @Output() unselected = new EventEmitter();
    @Output() search = new EventEmitter<{ field: string, value: string }>();
    @Output() pageChanged = new EventEmitter<{ pageInfo: {pageIndex: number, pageSize: number}, search: {field: string, value: string} }>();

    private _searchState = null;
    private _sortState = null;
    private allData = null;
    constructor(private cfr: ComponentFactoryResolver, private cd: ChangeDetectorRef) { }

    ngOnInit() {
        if (this.lookupCmp && this.isTreeList()) {
            this.lookupCmp.includeSubordinates$$ = this.lookupCmp.includeSubordinates$.subscribe((val: boolean) => {
                if (this.cmpRef) {
                    const tt = this.cmpRef.instance as TreeTableComponent;
                    if (tt.selectedRow) {
                        this.selected.emit({ data: tt.selectedRow.data, node: tt.selectedRow });
                    }
                }
            });
        }
    }

    ngOnDestroy(): void {
        this._searchState = null;
        this._sortState = null;
    }

    updateScrollPosition() {
        if (this.isTreeList()) {
            const tt = this.cmpRef.instance as TreeTableComponent;
            if (tt && tt.state.scrollY != tt.psRef.directiveRef.elementRef.nativeElement.scrolltop) {
                tt.psRef.directiveRef.scrollToY(tt.state.scrollY);
            }
        }
    }

    createComponent(): Observable<any> {
        let dtFac = null;
        if (!this.isTreeList()) {
            dtFac = this.cfr.resolveComponentFactory(DataTableComponent);
        } else {
            this.navOptions['fitColumns'] = false;
            this.navOptions['autoFitColumns'] = true;
            dtFac = this.cfr.resolveComponentFactory(TreeTableComponent);
        }
        this.navOptions['keepSelect'] = false;
        // å·¦ä¾§æ¥è¯¢è¿æ»¤æ¡ï¼éèæï¼
        this.navOptions['showFilterBar'] = this.lookupCmp.enableMultiFieldSearch? false: this.lookupCmp.showFilterBar;

        this.navOptions.width = this.lookupCmp.leftPanelWidth;

        this.cmpRef = this.cmpContainer.createComponent(dtFac);

        if (!this.isTreeList()) {
            this.navOptions.width -= 2;
            this.navOptions['fill'] = true;
            this.cmpRef.instance.maxSize = 5;
            this.cmpRef.instance.fill = true;
            this.cmpRef.instance.autoFitColumns = true;
        } else {
            this.navOptions['fit'] = true;
            this.navOptions.columns.forEach((col: any) => {
                col.showTips = true;
            });
        }
        // this.cmpRef.instance.fit = true;

        if (this.navOptions.pageInfo) {
            if (this.navOptions.pageInfo.pageList) {
                this.navOptions.pageList = this.navOptions.pageInfo.pageList;
            }
            this.navOptions.pagination = this.navOptions.pageInfo.enablePager;
            this.navOptions.pageIndex = this.navOptions.pageInfo.pageIndex;
            this.navOptions.pageSize = this.navOptions.pageInfo.pageSize;
        } else {
            this.navOptions.pagination = false;
        }

        Object.assign(this.cmpRef.instance, this.navOptions);

        this.loadData();
        return of(this.cmpRef);
    }

    update() {
        this.cd.detectChanges();
    }

    resize(size?: {width: number, height: number}) {
        if (size) {
            const { width, height } = size;
            const _width = width - 2;
            this.navOptions.width = _width;
            this.navOptions.height = height;

            const _height = height -  this.lookupCmp.getFilterBarHeight();
            this.cmpRef.instance.resize({ width: _width, height: _height });
        }
    }

    isTreeList() {
        return this.navOptions.displayType.toLowerCase() === 'treelist' && !this.lookupCmp.navTreeToList;
    }

    private selectLeftDataTableRow(items: any, dt: DataTableComponent) {
        if (items && items.length) {
            let item = null;
            if (this.lookupCmp.navSelectedIds) {
                item = items.find(n => n[dt.idField] == this.lookupCmp.navSelectedIds);
            } else {
                if (this.lookupCmp.selectFirstInNav) {
                    item = items[0];
                }
            }

            if (item) {
                dt.dtBody.selectedRowIndex = -1;
                dt.dtBody.selectedRow('', 0, item);
            }
        }
    }

    private closeLoading() {
        this.lookupCmp.closeLoading();
    }


    private  httpRequest(p: any, action: LOAD_DATA_TYPE = 'navsearch') {
        this.lookupCmp.showLoading();
        return this.lookupCmp.httpMgr.getData(p, action);
    };

    private initDataTable(dt: DataTableComponent) {
        dt.loadData({
            pageSize: this.navOptions.pageSize,
            pageIndex: this.navOptions.pageIndex,
            total: this.navOptions.total,
            data: this.navOptions.items,
        });

        const {width, height} = this.navOptions;
        // dt.resize({ width: 320, height: this.navOptions.height});
        dt.resize({ width, height: height -  this.lookupCmp.getFilterBarHeight() });
        // è¡éä¸­
        dt.selectedRow.subscribe(d => {
            this.selected.emit({ data: d.data });
        });

        dt.unSelectRow.subscribe(d => {
            this.selected.emit(null);
        });

        const loadTableData = {
            next: (data: LookupGridResult) => {
                this.closeLoading();
                dataTableReLoad(data);
                const {width, height} = this.navOptions;
                this.cmpRef.instance.resize({ width, height: height -  this.lookupCmp.getFilterBarHeight() });
            },
            error: (err) => {
                this.closeLoading();
            }
        };


        // æ¥è¯¢
        dt.search.subscribe( searchData => {
            const p: any = { pageInfo: { pageIndex: 1, pageSize: this.navOptions.pageSize }, search: '',navConditions: this.navConditions };

            this._searchState = searchData;
            this.search.emit(searchData);
            p.search = searchData;
            p.pageInfo.pageSize = dt.pageSize;
            this.lookupCmp.navigationFilter = null;

            if (this._sortState && this._sortState.sortName) {
                p['sortName'] = this._sortState.sortName;
                p['sortOrder'] = this._sortState.sortOrder;
            } else {
                delete p['sortName'];
                delete p['sortOrder'];
            }

            this.httpRequest(p).pipe(filter(n => n)).subscribe(loadTableData);
        });

        const dataTableReLoad = (data) => {
            dt.loadData({
                pageSize: data.pageInfo.pageSize,
                pageIndex: data.pageInfo.pageIndex,
                total: data.total,
                data: data.items,
            });

            this.selectLeftDataTableRow(data.items, dt);
            dt.cd.markForCheck();
        };

        // åé¡µ
        dt.pageChanged.subscribe(d => {
            this.pageChanged.emit(d);
            this.lookupCmp.navigationFilter = null;
            d.navConditions = this.navConditions || [];
            this.httpRequest(d).subscribe(loadTableData);
        });

        dt.pageSizeChanged.subscribe((e) => {
            this.lookupCmp.navigationFilter = null;
            e.navConditions = this.navConditions || [];
            this.httpRequest(e).subscribe(loadTableData);
        });

        dt.columnSorted.subscribe( (sort: {sortName: string, sortOrder: any}) => {
            const { sortName, sortOrder } = {...sort};
            this._sortState = sort;
            this.lookupCmp.navigationFilter = null;
            const param = { 
                sortName,
                sortOrder,
                search: this._searchState,  
                pageInfo: {
                    pageSize: dt.pageSize,
                    pageIndex: 1
                },
                navConditions: this.navConditions || []
            };
            this.httpRequest(param).subscribe(loadTableData);
        });

        dt.clearSearchValue.subscribe( () => {
            this._searchState = null;
            dt.search.emit(null);
        });

        this.selectLeftDataTableRow(this.navOptions.items, dt);
    }

    private buildParams(params: {}): {[key: string]:any} {
        const p: any = { 
            ...params, 
            treeToList: this.lookupCmp.treeToList, 
            navTreeToList: this.lookupCmp.navTreeToList,
            navConditions: this.navConditions || []
        };

        return p;
    }

    private initTreeTable(tt: TreeTableComponent) {
        tt.virtualized = true;
        tt.fast = true;
        tt.nodeSelected.subscribe(d => {
            this.selected.emit({data: d.node.data, node: d.node});
        });

        tt.nodeUnSelect.subscribe(d => {
            this.selected.emit(null);
        });

        tt.fixedHeader = true;

        if (this.navOptions.treeInfo.loadDataType === 'all') { // åå±å è½½ä¸æ¯æåæ°æ¶éç½®å±å¼å±çº§
            this.lookupCmp.treeNodeHelper.updateTreeNodeExpanded(this.navOptions.items, this.navOptions.treeInfo);
        }

        tt.loadDataType = this.navOptions.treeInfo.loadDataType;
        // æ£æ¥å®æ´æ è¿æ»¤æ¡ä»¶ By Lucas 20200302
        this.navOptions.items = this.lookupCmp.checkNodeCanBeSelect(this.navOptions.items, this.navOptions.treeInfo.loadDataType === 'all');
        tt.loadData(this.navOptions.items);

        if (this.lookupCmp.navSelectedIds) {
            tt.selectNode(this.lookupCmp.navSelectedIds);
        } else if (this.lookupCmp.selectFirstInNav) {
            tt.selectFirstNode();
        }

        this.allData = this.navOptions.items;

        const loadTreeData = {
            next: (resData: any) => {
                this.closeLoading();
                tt.psRef.directiveRef.scrollToTop(0);
                tt.clearAll();
                const items = this.lookupCmp.checkNodeCanBeSelect(resData.items, this.navOptions.treeInfo.loadDataType === 'all' && (!this._searchState || !this._searchState.value));

                if (items && items.length && items[0].children && items[0].children.length) {
                    items[0].expanded = true;
                    items[0].children = this.lookupCmp.expandFirstNode(items[0].children);
                }

                tt.loadData(items);
                tt.resize();
                this.selected.emit(null);
            },
            error: (err) => {
                this.closeLoading();
            }
        };


        tt.search.subscribe(search => {
            this._searchState = search;
            this.lookupCmp.navigationFilter = null;
            const p = this.buildParams({ search });
          
            if (this._sortState && this._sortState.sortName) {
                p['sortName'] = this._sortState.sortName;
                p['sortOrder'] = this._sortState.sortOrder;
            }
            this.httpRequest(p).subscribe(loadTreeData);
        });

        tt.columnSorted.subscribe( (sort: {sortName: string, sortOrder: any}) => {
            this.lookupCmp.navigationFilter = null;
            if (tt.loadDataType === 'all') {
                tt.clientSort();
            } else {
                let { sortName, sortOrder } = {...sort};

                const sortCol: any = this.navOptions.columns.find(n => n.field === sortName);
                if (sortCol) {
                    sortName = sortCol['fieldPath'];
                }

                this._sortState = { sortName, sortOrder };
                // const param = Object.assign({ sortName, sortOrder }, this._searchState);
                const param = this.buildParams({ sortName, sortOrder, search: this._searchState });
                let requestType: LOAD_DATA_TYPE = 'nav';
                if ((this._searchState && this._searchState.value) || (param && param.navConditions && param.navConditions.length)) {
                    requestType = 'navsearch';
                }

                this.httpRequest(param, requestType).subscribe(loadTreeData);
            }
        });

        tt.clearSearchValue.subscribe( () => {
            this._searchState = null;
            if (!this._sortState || !this._sortState.sortName) {
                tt.loadData(this.allData);
                if (!tt.selectedRow) {
                    this.selected.emit(null);
                }
            } else {
                const p = this.buildParams({});
                this.lookupCmp.navigationFilter = null;
                if (this._sortState && this._sortState.sortName) {
                    p['sortName'] = this._sortState.sortName;
                    p['sortOrder'] = this._sortState.sortOrder;
                }
                this.httpRequest(p, 'nav').subscribe(loadTreeData);
            }
        });


        tt.expand.subscribe((tn: any) => {
            this.onNodeExpanded(tn, tt);
        });
    }


    private onNodeExpanded(tn: any, tt) {
        if (tn.leaf) {
            return;
        }
        if (!tn.children || !tn.children.length) {
            const treeInfo = this.navOptions.treeInfo;
            let parentPath = '';
            let parentLayer = -1;
            const { field = '*', value = '' } = {
                ...tt.searchData
            };

            tn['showLoading'] = true;
            tt.detectChanges();
            if (treeInfo.layerType === 'parentId') {
                // ç¶IDå è½½æ¹å¼
                parentPath = tn['id'];
            } else {
                const treeInfoField = treeInfo.dataField;
                if (treeInfoField) {
                    // parentPath = tn.data[treeInfoField][treeInfo.pathField];
                    // parentLayer = tn.data[treeInfoField][treeInfo.layerField];
                    parentPath = this.lookupCmp.getPathCode(tn.data, treeInfo);
                    parentLayer= this.lookupCmp.getLayerData(tn.data, treeInfo);
                } else {
                    console.log('æªæ¾å°åçº§ä¿¡æ¯ã');
                }
            }

            if (!this.lookupCmp.uri) {
                this.lookupCmp.expandTreeNode.emit({
                    instance: tt, node: tn,
                    parentIdOrPath: parentPath, parentLayer, search: { value, field }
                });

                return;
            }

            this.lookupCmp.showLoading();
            this.getChildren(
                parentPath, parentLayer, {searchField: field === '*' ? '*' : field, searchValue: value}, tt
            ).pipe(
                switchMap((data: any) => {
                    if (data && data.items && data.items.length) {
                        return of(data);
                    } else {
                        return this.getChildren(parentPath, parentLayer, { searchField: '*', searchValue: ''  }, tt, true);
                    }
                })
            ).subscribe(data => {
                this.lookupCmp.closeLoading();
                if (tt) {
                    if (tn && data.items && data.items.length) {
                        tt.appendChildren(data.items, tn);
                    }
                    tn['showLoading'] = false;
                    tt.detectChanges();
                }
            });
        }
    }

    private getChildren( parentPath, parentLayer, searchData: { searchField: string; searchValue: string }, tt, all = false ): Observable<any> {
        const uri = this.lookupCmp.gridOptions.uri;
        const search = { parentLayer, category: 'navchildren', ...searchData };
        if (this.navOptions.treeInfo.layerType === 'parentId') {
            search['parentId'] = parentPath;
        } else {
            search['parentPath'] = parentPath;
        }

        const param: any = this.buildParams({
            searchValue: JSON.stringify(search),
            customData: this.lookupCmp.customData,
            enableFullTree: false,
            loadTreeDataType: 'layerload',
        });

        if (this.lookupCmp.helpId) {
            param['helpId'] = this.lookupCmp.helpId;
        }

        if (tt && tt.sortName) {
            let sortName = tt.sortName;
            const sortCol: any = this.navOptions.columns.find(n => n.field === tt.sortName);
            if (sortCol) {
                sortName = sortCol['fieldPath'];
            }

            search['sortName'] = sortName;
            search['sortOrder'] = tt.sortOrder;
            param.searchValue = JSON.stringify(search);
        }

        if (this.navConditions && this.navConditions.length && !all) {
            param.navSearchConditions = this.navConditions;
        }
        delete param.navConditions;
        return this.lookupCmp.http.getData(uri , param);
    }


    loadData() {
        this.cmpRef.instance.allColumnsTitle = this.lookupCmp.allColumnsTitle;
        if (!this.isTreeList()) {
            const dt = this.cmpRef.instance as DataTableComponent;
            this.initDataTable(dt);
        } else {
            const tt = this.cmpRef.instance as TreeTableComponent;
            this.initTreeTable(tt);
        }
    }

    onConditionsChange($event) {
        this.navConditions = $event;
        if (this.isTreeList()) {
            const tt = this.cmpRef.instance as TreeTableComponent;
            tt.search.emit();
        } else {
            const dt = this.cmpRef.instance as DataTableComponent;
            dt.search.emit();
        }
    }
}
